var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.33385C7.3385 9.33385 8.52728 8.72883 9.08333 7.7574V8.34219C9.08333 9.78898 7.72564 11.0005 6 11.0005C4.27436 11.0005 2.91667 9.78898 2.91667 8.34219V7.7574C3.47272 8.72883 4.6615 9.33385 6 9.33385Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.333333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.25 3.99219V6.49219C9.25 8.05219 7.795 9.16719 6 9.16719C4.205 9.16719 2.75 8.05219 2.75 6.49219V3.99219C2.75 4.44719 2.875 4.86719 3.095 5.22719C3.63 6.10719 4.73 6.66719 6 6.66719C7.27 6.66719 8.37 6.10719 8.905 5.22719C9.125 4.86719 9.25 4.44719 9.25 3.99219Z",
    fill: "#92ABFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.99199C9.25 4.44699 9.125 4.86699 8.905 5.22699C8.37 6.10699 7.27 6.66699 6 6.66699C4.73 6.66699 3.63 6.10699 3.095 5.22699C2.875 4.86699 2.75 4.44699 2.75 3.99199C2.75 2.43199 4.205 1.16699 6 1.16699C6.9 1.16699 7.71 1.48199 8.3 1.99199C8.885 2.50699 9.25 3.21199 9.25 3.99199Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.0399f87c87d69a9d97fd1efb32552c79.svg";
export { ForwardRef as ReactComponent };